<template>
    <div class="table_wrap">
        <el-table class="list-table" header-cell-class-name="list-header" :data="declarationData"
                  style="width: 100%;" height="695" empty-text="데이터가 없습니다."
                  >
            <el-table-column
                    class="table_no"
                    type="index"
                    label="No"
                    min-width="70"
                    class-name="num text-center"
                    :index="tableIdx"
            >
            </el-table-column>
            <el-table-column label="신고자 아이디" width="" class-name="text-center" prop="reporterId"></el-table-column>
            <el-table-column label="신고자 닉네임" width="" class-name="text-center" prop="reporterNick"></el-table-column>
            <el-table-column label="신고당한 아이디" width="" class-name="text-center" prop="reportedId"></el-table-column>
            <el-table-column label="신고당한 닉네임" width="" class-name="text-center" prop="reportedNick"></el-table-column>
            <el-table-column
                    label="신고일시" min-width="" class-name="text-center">
                <template slot-scope="scope">
                    <span>
                        {{ returnDateUnix(scope.row.created, 'YYYY-MM-DD HH:mm') }}
                    </span>
                </template>
            </el-table-column>
            <el-table-column
                    label="신고상세" width="85" class-name="text-center">
                <template slot-scope="scope">
                    <div class="row-info">
                        <el-button @click="goDetail(scope.row.reportId)">
                            상세
                        </el-button>
                    </div>
                </template>
            </el-table-column>
            <el-table-column
                    label="프로필" width="85" class-name="text-center">
                <template slot-scope="scope">
                    <div class="row-info">
                        <el-button @click="goProfile(scope.row.reportedNo)">
                            바로가기
                        </el-button>
                    </div>
                </template>
            </el-table-column>
            <el-table-column
                    label="패널티적용" width="85" class-name="text-center">
                <template slot-scope="scope">
                    <div class="row-info">
                        <el-button @click="runPenalty(scope.row.reportedNo)">
                            적용
                        </el-button>
                    </div>
                </template>
            </el-table-column>
        </el-table>
    </div>
</template>

<script>
import util from "@/mixins/util";
import EventBus from "@/utils/event-bus";
import dateMixins from "@/mixins/dateMixins";

export default {
    name: "DeclarationFirebaseListLayout",
    mixins: [dateMixins],
    inject: [],
    components: {},
    provide() {
        return {}
    },
    props: {
        declarationData: {default: () => []},
        paginationData: {
            default: () => {
                return {total: 0, page: 0, size: 0,}
            }
        },
    },
    data() {
        return {
        }
    },
    created() {
    },
    mounted() {
    },
    beforeDestroy() {
    },
    destroyed() {
    },
    computed: {},
    methods: {
        tableIdx(index) {
            return this.paginationData.total - index;
        },
            goProfile(idx) {
                this.$router.push(`/student/member/${idx}`);
            },
            runPenalty(idx){
                this.createConfirm({
                    content: '패널티를 추가하시겠습니까?',
                    confirm: () => {
                        this.addPenalty(idx)
                    }
                })
            },
            addPenalty(mb_no) {
                let params ={
                    mb_no : mb_no
                }
                try {
                    this.$api.$declaration.penaltyDeclaration(params).then(res => res.Data.Result).then(res => {
                        if(res.Info.type != 1){
                            this.errorAlert('패널티 추가에 실패했습니다.')
                            return
                        }else {
                            this.createAlert({
                                content: '패널티 카운트가 추가되었습니다.',
                            })
                        }
                    })
                }
                catch (e) {

                }

            },
            goDetail(idx) {
              this.$router.push(`openChat/${idx}`);
            },
    },
    watch: {},
}
</script>

<style scoped>

</style>